module.exports = __webpack_public_path__ + "bfb6c9e68b92fdcb052b9010ffb3dbec.pdf";